import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TestPrioritizationState } from '../states/test-prioritization.state';

export const selectTestPrioritizationState = createFeatureSelector<TestPrioritizationState>('testPrioritization');

// Select test cases data
export const selectTestCasesToSourceMapping = createSelector(
  selectTestPrioritizationState,
  (state) => state.testCasesToSourceMapping
);

// Select loading status
export const selectTestPrioritizationLoading = createSelector(
  selectTestPrioritizationState,
  (state) => state.loading
);

// Select error state
export const selectTestPrioritizationError = createSelector(
  selectTestPrioritizationState,
  (state) => state.error
);

//Select isMappingCreated state
export const selectTestPrioritizationIsMappingCreated = createSelector(
  selectTestPrioritizationState,
  (state) => state.isMappingCreated
);

export const selectMappingResponse = createSelector(
  selectTestPrioritizationState,
  (state) => state.mappingResponse
);

export const selectRecommendations = createSelector(
  selectTestPrioritizationState,
  (state) => state.recommandations
);

export const selectLoading = createSelector(
  selectTestPrioritizationState,
  (state) => state.loading
);
